import { Avatar, Box, IconButton, Typography } from "@material-ui/core";
import MenuIcon from '@mui/icons-material/Menu';
import Logout from '@mui/icons-material/Logout';
import { Menu, MenuItem, Stack } from "@mui/material";
import ListItemIcon from '@mui/material/ListItemIcon';
import React, { useContext, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../context/ThemeProvider";
import Style from "../css/navbar.module.scss";
import { zIndex } from "material-ui/styles";


export default function Nabvar() {
  const navigate = useNavigate()
  const { drawerSilde, setDrawerSilde } = useContext(ThemeContext)
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOptionEl = (event, value) => {
    setAnchorEl(event.currentTarget);
  }

  const handleCloseMenu = (event) => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.clear()
    navigate('/login')
  }



  return (
    <Box className={drawerSilde ? Style.nav_open : Style.nav_close} style={{zIndex:"20"}}>
      <Stack direction='row' alignItems='center'>
        <Stack direction='row' alignItems='center'>
          <IconButton onClick={() => setDrawerSilde(!drawerSilde)} ><MenuIcon /></IconButton>
          <Typography sx={{ color: '#fff' }} variant="h5">Voucher Panel</Typography>
        </Stack>
      </Stack>
      <IconButton onClick={handleOptionEl}>
        <Avatar color="info" />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 6,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'left', }}
        transformOrigin={{ vertical: 'top', horizontal: 'left', }}
      >
        <MenuItem onClick={handleLogout}><ListItemIcon><Logout fontSize="small" /></ListItemIcon>LogOut</MenuItem>
      </Menu>
    </Box>
  );
}
